import * as React from 'react';
import Link from '@mui/material/Link';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { List, ListItem } from '@mui/material';

function LightBulbIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z" />
    </SvgIcon>
  );
}

export default function ProTip() {
  return (
    <>
      <Typography sx={{ mt: 3, mb: 2, fontSize: 18, mx: 2 }} color="text.secondary">
        {/* <LightBulbIcon sx={{ mr: 1, verticalAlign: 'middle' }} /> */}
        <Link rel="noopener norefferer" target="_blank" href="https://en.wikipedia.org/wiki/DocuDays_UA"> The DocuDays UA (International Human Rights Documentary Film Festival)</Link> is gathering funds to support Ukrainian based filmmakers in their effort to capture and document the events that take place in their country. The funds will not be used to support the war effort.
        <Typography sx={{fontSize: 22, mt: 2}} color="text.secondary">Purposes for collecting money are the following:</Typography>
        <List>
          <ListItem>
            1. Emergency fund for filmmakers - we need to have a particular amount in our hands to be able to quickly help filmmakers if they are in an emergency situation with small amounts like 500-1000-2000 euros
          </ListItem>
          <ListItem>2. Gasoline</ListItem>
          <ListItem>3. Technical filming equipment</ListItem>
        </List>
        <List sx={{ml: -2}}>
          <ListItem>
            <Link rel="noopener norefferer" target="_blank" href="https://www.imdb.com/name/nm5385015/?ref_=nv_sr_srsg_0">
              Darya Bassel, producer
            </Link>
          </ListItem>
          <ListItem>
            <Link rel="noopener norefferer" target="_blank" href="https://m.imdb.com/name/nm6568613/?ref_=nv_sr_srsg_0">
              Yelizaveta Smith, director
            </Link>
          </ListItem>
          <ListItem>
            <Link rel="noopener norefferer" target="_blank" href="https://www.imdb.com/name/nm5596313/?ref_=nv_sr_srsg_0">
              Alina Gorlova, director</Link>
          </ListItem>
          <ListItem>
            <Link rel="noopener norefferer" target="_blank" href="https://m.imdb.com/name/nm6568617/?ref_=nv_sr_srsg_0">
              Maksym Nakonechnyi, director
            </Link>
          </ListItem>
          <ListItem>
            <Link rel="noopener norefferer" target="_blank" href="https://m.imdb.com/name/nm9766830/?ref_=nv_sr_srsg_0">
              Simon Mozgovyi, director
            </Link>
          </ListItem>
          <ListItem>
            <Link rel="noopener norefferer" target="_blank" href="https://m.imdb.com/name/nm5335723/?ref_=nv_sr_srsg_0">
              Viacheslav Tsvietkov, dop
            </Link>
          </ListItem>
          <ListItem>
            <Link rel="noopener norefferer" target="_blank" href="https://m.imdb.com/name/nm6568615/?ref_=nv_sr_srsg_0">
              Khrystyna Lizogub, dop
            </Link>
          </ListItem>
          <ListItem>
            {/*<Link rel="noopener norefferer" target="_blank" href="https://m.imdb.com/name/nm6568613/)">*/}
              Denys Melnyk, dop
            {/*</Link>*/}
          </ListItem>
          <ListItem>
            <Link rel="noopener norefferer" target="_blank" href="https://m.imdb.com/name/nm6339927/?ref_=nv_sr_srsg_0">
              Olga Zhurba, editor
            </Link>
          </ListItem>
        </List>
      </Typography>
    </>

  );
}
